const FJImageUtil = {
    loadImageLegency: function (src, oriImage) {
        return new Promise((resolve, reject) => {
            let image = oriImage || new Image();
            image.setAttribute('crossOrigin', 'anonymous');
            image.onload = () => resolve(image);
            image.onerror = () => reject(image);
            image.onabort = () => reject(image);
            image.src = src;
        });
    },

    loadImage: async function (src, oriImage) {
        try {
            const image = oriImage || new Image();
            image.src = src;
            await image.decode();
            return image;
        } catch (e) {
            return this.loadImageLegency(src, oriImage);
        }
    },
};

export default FJImageUtil;
